export enum FormSelectStyle {
    Default = 'sh-select',
    Ghost = 'sh-select--ghost',
    Inline = 'sh-select--inline'
}
